module.exports = __webpack_public_path__ + "img/category-casino.e8054cdd.png";